import { render, staticRenderFns } from "./PostFile.vue?vue&type=template&id=47c43bf4&"
import script from "./PostFile.vue?vue&type=script&lang=js&"
export * from "./PostFile.vue?vue&type=script&lang=js&"
import style0 from "./PostFile.vue?vue&type=style&index=0&id=47c43bf4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports